'use strict';

/**
 * Internationalize a message and format it. See utils.format for details.
 * */
customerZone.filter('format', ['utils', function(utils){
    return function(input, parameters){
        return utils.format(input, parameters);
    };
}]);
